module.exports = __webpack_public_path__ + "static/media/gc-athens-arrival.6b3a0913.png";